import React, { useState } from 'react';
import { login } from '../api';

export default function LoginPage({ onLogin }) {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    if (!email || !senha) { setErro('Preencha todos os campos'); return; }
    setLoading(true);
    try { const data = await login(email, senha); onLogin(data.usuario); }
    catch (err) { setErro(err.message); }
    setLoading(false);
  };

  return (
    <div className="lgn">
      <div className="lc">
        <span className="lgn-ico">🥗</span>
        <h1>Marmitas Fit</h1>
        <p>Entre para gerenciar o seu negócio</p>
        {erro && <div className="err">⚠️ {erro}</div>}
        <form className="fm" onSubmit={handleSubmit}>
          <input
            className="inp" type="email" placeholder="Seu e-mail"
            value={email} onChange={(e) => setEmail(e.target.value)}
            autoFocus autoComplete="email"
          />
          <input
            className="inp" type="password" placeholder="Sua senha"
            value={senha} onChange={(e) => setSenha(e.target.value)}
            autoComplete="current-password"
          />
          <button className="btn btn1 btn-lg" type="submit" disabled={loading}
            style={{ marginTop: 4 }}>
            {loading ? 'Entrando...' : '🔓 Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}
